export default function(str, maxLength) {
  const suffix = '...'
  if (str.length > maxLength + suffix.length) {
    return str.substring(0, maxLength) + suffix
  } else {
    return str
  }
}
